import { Fragment } from 'react'

import ExamplesSection from './ExamplesSection/ExamplesSection'
import BannerSection from './BannerSection/BannerSection'
import FactsSection from './FactsSection.tsx/FactsSection'
import IntroductionSection from './IntroductionSection/IntroductionSection'
import { SecondhandTaxesLandingPageSection } from '../constants'
import QuestionsSection from './QuestionsSection/QuestionsSection'
import TipSection from './TipSection/TipSection'
import ListingSection from './ListingSection/ListingSection'
import {
  BannerSectionModel,
  ExamplesSectionModel,
  FactsSectionModel,
  IntroductionSectionModel,
  ListingSectionModel,
  ProofSectionModel,
  QuestionsSectionModel,
  SecondhandTaxesPageModel,
  TipSectionModel,
} from '../types'
import ProofSection from './ProofSection/ProofSection'

const getData = (data: SecondhandTaxesPageModel) => (id: SecondhandTaxesLandingPageSection) =>
  data.find(({ componentId }) => componentId === id)

const SecondhandTaxesComponentsRenderer = ({ content }: { content: SecondhandTaxesPageModel }) => {
  const getDataBySection = getData(content)
  const { Introduction, Banner, Examples, Facts, Questions, Tip, Listing, Proof } =
    SecondhandTaxesLandingPageSection

  return (
    <main className="secondhand-taxes__wrapper">
      {content.map(datum => {
        return (
          <Fragment key={datum.componentId}>
            {(() => {
              switch (datum.componentId) {
                case Introduction:
                  return (
                    <IntroductionSection
                      props={getDataBySection(Introduction) as IntroductionSectionModel}
                    />
                  )
                case Facts:
                  return <FactsSection props={getDataBySection(Facts) as FactsSectionModel} />
                case Examples:
                  return (
                    <ExamplesSection props={getDataBySection(Examples) as ExamplesSectionModel} />
                  )
                case Banner:
                  return <BannerSection props={getDataBySection(Banner) as BannerSectionModel} />
                case Questions:
                  return (
                    <QuestionsSection
                      props={getDataBySection(Questions) as QuestionsSectionModel}
                    />
                  )
                case Tip:
                  return <TipSection props={getDataBySection(Tip) as TipSectionModel} />
                case Listing:
                  return <ListingSection props={getDataBySection(Listing) as ListingSectionModel} />
                case Proof:
                  return <ProofSection props={getDataBySection(Proof) as ProofSectionModel} />
                default:
                  return null
              }
            })()}
          </Fragment>
        )
      })}
    </main>
  )
}

export default SecondhandTaxesComponentsRenderer
